import React, { type FunctionComponent, useEffect } from 'react'
import {
  AttributeManagementNextStepTypeEnum,
  type PipelineStep,
} from '../../../types/attributeManagement.types.ts'

interface Props {
  step: PipelineStep
  onChange: (step: PipelineStep) => void
}

export const PipelineFormStepControlHalt: FunctionComponent<Props> = ({ step, onChange }) => {
  useEffect(() => {
    if (step && step?.nextStepsRule?.type != AttributeManagementNextStepTypeEnum.Halt) {
      onChange({
        ...step,
        nextStepsRule: {
          type: AttributeManagementNextStepTypeEnum.Halt,
          possibleNextSteps: [],
        },
      })
    }
  }, [onChange, step])

  return <></>
}
